export function truncateStart(array, size) {
  if (array.length > size) {
    array.splice(0, array.length - size);
  }
}

export function truncateEnd(array, size) {
  array.length = size;
}
